export default __webpack_public_path__ + "static/media/line.858a6a19.svg";